__turbopack_context__.v({
  "arrowBtn": "general-module__ilN9uq__arrowBtn",
  "audioAgentName": "general-module__ilN9uq__audioAgentName",
  "audioAgentStatus": "general-module__ilN9uq__audioAgentStatus",
  "audioAvatar": "general-module__ilN9uq__audioAvatar",
  "audioLabel": "general-module__ilN9uq__audioLabel",
  "audioPlayBtn": "general-module__ilN9uq__audioPlayBtn",
  "audioPlayIcon": "general-module__ilN9uq__audioPlayIcon",
  "audioStatusDot": "general-module__ilN9uq__audioStatusDot",
  "audioStatusDotActive": "general-module__ilN9uq__audioStatusDotActive",
  "audioWaveBar": "general-module__ilN9uq__audioWaveBar",
  "audioWaveBarActive": "general-module__ilN9uq__audioWaveBarActive",
  "audioWaveform": "general-module__ilN9uq__audioWaveform",
  "audioWidget": "general-module__ilN9uq__audioWidget",
  "audioWidgetHeader": "general-module__ilN9uq__audioWidgetHeader",
  "ctaBtn": "general-module__ilN9uq__ctaBtn",
  "ctaImage": "general-module__ilN9uq__ctaImage",
  "ctaInner": "general-module__ilN9uq__ctaInner",
  "ctaOverlay": "general-module__ilN9uq__ctaOverlay",
  "ctaSection": "general-module__ilN9uq__ctaSection",
  "ctaSubtitle": "general-module__ilN9uq__ctaSubtitle",
  "ctaTitle": "general-module__ilN9uq__ctaTitle",
  "fcIllusArea": "general-module__ilN9uq__fcIllusArea",
  "fcPulse": "general-module__ilN9uq__fcPulse",
  "fcSubtitle": "general-module__ilN9uq__fcSubtitle",
  "fcTextArea": "general-module__ilN9uq__fcTextArea",
  "fcTitle": "general-module__ilN9uq__fcTitle",
  "fcWave": "general-module__ilN9uq__fcWave",
  "featureCard": "general-module__ilN9uq__featureCard",
  "featuresGrid": "general-module__ilN9uq__featuresGrid",
  "featuresInner": "general-module__ilN9uq__featuresInner",
  "featuresSection": "general-module__ilN9uq__featuresSection",
  "hero": "general-module__ilN9uq__hero",
  "heroBtnPrimary": "general-module__ilN9uq__heroBtnPrimary",
  "heroBtnSecondary": "general-module__ilN9uq__heroBtnSecondary",
  "heroBtns": "general-module__ilN9uq__heroBtns",
  "heroContent": "general-module__ilN9uq__heroContent",
  "heroImage": "general-module__ilN9uq__heroImage",
  "heroLayout": "general-module__ilN9uq__heroLayout",
  "heroOverlay": "general-module__ilN9uq__heroOverlay",
  "heroSubtitle": "general-module__ilN9uq__heroSubtitle",
  "heroTag": "general-module__ilN9uq__heroTag",
  "heroTitle": "general-module__ilN9uq__heroTitle",
  "howItWorksHeader": "general-module__ilN9uq__howItWorksHeader",
  "howItWorksSection": "general-module__ilN9uq__howItWorksSection",
  "howSubtitle": "general-module__ilN9uq__howSubtitle",
  "howTitle": "general-module__ilN9uq__howTitle",
  "howTitleItalic": "general-module__ilN9uq__howTitleItalic",
  "illusAgent": "general-module__ilN9uq__illusAgent",
  "illusApptCard": "general-module__ilN9uq__illusApptCard",
  "illusApptConfirm": "general-module__ilN9uq__illusApptConfirm",
  "illusApptRow": "general-module__ilN9uq__illusApptRow",
  "illusApptTitle": "general-module__ilN9uq__illusApptTitle",
  "illusCallBadge": "general-module__ilN9uq__illusCallBadge",
  "illusCallDot": "general-module__ilN9uq__illusCallDot",
  "illusCallNumber": "general-module__ilN9uq__illusCallNumber",
  "illusCallWrap": "general-module__ilN9uq__illusCallWrap",
  "illusDoc": "general-module__ilN9uq__illusDoc",
  "illusDocBack1": "general-module__ilN9uq__illusDocBack1",
  "illusDocBack2": "general-module__ilN9uq__illusDocBack2",
  "illusDocFront": "general-module__ilN9uq__illusDocFront",
  "illusDocIcon": "general-module__ilN9uq__illusDocIcon",
  "illusFaqBadge": "general-module__ilN9uq__illusFaqBadge",
  "illusFaqCard": "general-module__ilN9uq__illusFaqCard",
  "illusFaqRow": "general-module__ilN9uq__illusFaqRow",
  "illusFaqTitle": "general-module__ilN9uq__illusFaqTitle",
  "illusLangBubble": "general-module__ilN9uq__illusLangBubble",
  "illusLangTag": "general-module__ilN9uq__illusLangTag",
  "illusLangText": "general-module__ilN9uq__illusLangText",
  "illusLangWrap": "general-module__ilN9uq__illusLangWrap",
  "illusLive": "general-module__ilN9uq__illusLive",
  "illusLiveBadge": "general-module__ilN9uq__illusLiveBadge",
  "illusLiveDot": "general-module__ilN9uq__illusLiveDot",
  "illusLiveList": "general-module__ilN9uq__illusLiveList",
  "illusPanel": "general-module__ilN9uq__illusPanel",
  "illusPanelLabel": "general-module__ilN9uq__illusPanelLabel",
  "illusPanelOn": "general-module__ilN9uq__illusPanelOn",
  "illusPanelRow": "general-module__ilN9uq__illusPanelRow",
  "illusPanelValue": "general-module__ilN9uq__illusPanelValue",
  "illusPhone": "general-module__ilN9uq__illusPhone",
  "illusPhoneBadge": "general-module__ilN9uq__illusPhoneBadge",
  "illusPhoneLabel": "general-module__ilN9uq__illusPhoneLabel",
  "illusPhoneNum": "general-module__ilN9uq__illusPhoneNum",
  "illusRouteBadge": "general-module__ilN9uq__illusRouteBadge",
  "illusRouteCard": "general-module__ilN9uq__illusRouteCard",
  "illusRouteRow": "general-module__ilN9uq__illusRouteRow",
  "illusRouteTitle": "general-module__ilN9uq__illusRouteTitle",
  "illusStack": "general-module__ilN9uq__illusStack",
  "illusStatusBadge": "general-module__ilN9uq__illusStatusBadge",
  "illusStatusEst": "general-module__ilN9uq__illusStatusEst",
  "illusStatusMsg": "general-module__ilN9uq__illusStatusMsg",
  "illusStatusWrap": "general-module__ilN9uq__illusStatusWrap",
  "illusWaveBar": "general-module__ilN9uq__illusWaveBar",
  "illusWaveBars": "general-module__ilN9uq__illusWaveBars",
  "livePulse": "general-module__ilN9uq__livePulse",
  "page": "general-module__ilN9uq__page",
  "sectionHeader": "general-module__ilN9uq__sectionHeader",
  "sectionLabel": "general-module__ilN9uq__sectionLabel",
  "slideCard": "general-module__ilN9uq__slideCard",
  "slideCard1": "general-module__ilN9uq__slideCard1",
  "slideCard2": "general-module__ilN9uq__slideCard2",
  "slideCard3": "general-module__ilN9uq__slideCard3",
  "slideCard4": "general-module__ilN9uq__slideCard4",
  "slideDesc": "general-module__ilN9uq__slideDesc",
  "slideIllus": "general-module__ilN9uq__slideIllus",
  "slideNum": "general-module__ilN9uq__slideNum",
  "slideText": "general-module__ilN9uq__slideText",
  "slideTitle": "general-module__ilN9uq__slideTitle",
  "sliderArrows": "general-module__ilN9uq__sliderArrows",
  "sliderViewport": "general-module__ilN9uq__sliderViewport",
});
